import { PureComponent, Fragment } from "react";

import SignupWithTextComponent from "/components/core/signups/signup-with-text/signup-with-text-component";
import Picture from "/components/core/picture/picture-component";
import { StyledArticleItemComponent } from "./article-item-component.scss";
import CompetitorsComparisonTableComponent from "/components/segments/competitors-comparison-table/competitors-comparison-table-component";
import { withGenericConfig } from "contexts/generic-config-context";

class ArticleItemComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.renderSignup = this.renderSignup.bind(this);
    this.renderParagraph = this.renderParagraph.bind(this);
    this.renderImage = this.renderImage.bind(this);
    this.renderHighlight = this.renderHighlight.bind(this);
    this.renderComparisonTable = this.renderComparisonTable.bind(this);
  }

  renderSignup() {
    const { title } = this.props;

    return <SignupWithTextComponent title={title} />;
  }

  renderImage() {
    const { src, alt } = this.props;
    return (
      <div className="article-image">
        <Picture src={src} alt={alt} />
      </div>
    );
  }

  renderParagraph() {
    const { title, isHighlight, content } = this.props;
    return (
      <Fragment>
        {title && <h1 className="paragraph-title" dangerouslySetInnerHTML={{ __html: title }} />}
        {content && <div className="paragraph-content" dangerouslySetInnerHTML={{ __html: content }} />}
      </Fragment>
    );
  }

  renderComparisonTable() {
    return <CompetitorsComparisonTableComponent {...this.props} />;
  }

  renderHighlight() {
    const { content } = this.props;
    return <div className="highlight-item">{content}</div>;
  }

  mapPartTypeToRenderer() {
    const { partType } = this.props;

    switch (partType) {
      case "paragraph": {
        return this.renderParagraph;
      }
      case "signup": {
        return this.renderSignup;
      }
      case "image": {
        return this.renderImage;
      }
      case "highlight": {
        return this.renderHighlight;
      }
      case "comparisonTable": {
        return this.renderComparisonTable;
      }
    }
  }

  render() {
    const { partType, content, title } = this.props;
    const partRenderer = this.mapPartTypeToRenderer();

    return (
      <StyledArticleItemComponent className={`article-item-component ${partType}`}>
        {partRenderer()}
      </StyledArticleItemComponent>
    );
  }
}

export default withGenericConfig(ArticleItemComponent);
